export default __webpack_public_path__ + "static/background-hero-0d390801ef625e6bfd53c0db86a7e524.png";